import { getCustomProps, getNotCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface LeaveReason {
  id?: string
  name: string
  code: string
  countryId: string
  masterConcepts: string[]
}

export async function getLeaveReasons(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['leave_reasons.country_id = :countryId']
  if (search) {
    where.push(
      `CONCAT(master_concepts.name, leave_reasons.name, leave_reasons.code, leave_reasons.is_inactive, leave_reasons.updated_at) ILIKE '%${search}%'`
    )
  }
  // order by
  const modifier = ['GROUP BY leave_reasons.id']
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? modifier.push(
          `ORDER BY (CASE WHEN leave_reasons.code ~ '^[0-9]+$' THEN CAST(leave_reasons.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, leave_reasons.code ${dataOrder[0]}`
        )
      : modifier.push(`order by ${dataOrder[1]} ${dataOrder[0]}`)
    : modifier.push(
        "ORDER BY (CASE WHEN leave_reasons.code ~ '^[0-9]+$' THEN CAST(leave_reasons.code AS NUMERIC) ELSE NULL END), leave_reasons.code"
      )
  // result
  const response: any = await getData({
    tables: ['pg_leave_reasons'],
    fields: [
      'leave_reasons.id',
      'leave_reasons.name',
      'leave_reasons.code',
      "coalesce(string_agg(distinct master_concepts.name,','),'') as masterConcepts",
      'leave_reasons.is_inactive',
      'leave_reasons.updated_at'
    ],
    join: [
      'LEFT JOIN LATERAL jsonb_array_elements_text(leave_reasons.master_concepts) r(master_concept) ON TRUE',
      'LEFT JOIN master_concepts ON master_concepts.id = r.master_concept::uuid'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getLeaveReason(id: string): Promise<LeaveReason> {
  const data = await getData<any>({
    tables: ['pg_leave_reasons'],
    fields: [
      'id',
      'code',
      'name',
      'master_concepts as masterConcepts',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createLeaveReason(data: any): Promise<boolean> {
  const response: any = await http.post('liquidation/leave-reasons', {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateLeaveReason(
  data: LeaveReason,
  id: string
): Promise<boolean> {
  const response: any = await http.put('liquidation/leave-reasons/' + id, {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function stateLeaveReason(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(
    `liquidation/leave-reasons/${id}/enable`,
    {
      enable
    }
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
